import CloseButton from '@Components/Common/CloseButton';
import OwnableTheme from '@Theme';
import { observer } from 'mobx-react-lite';
import { StyleSheet, View, useWindowDimensions } from 'react-native';

type Props = {
  onPress?: () => void;
};

export const SmartCloseButton = observer(function SmartCloseButton({
  onPress,
}: Props) {
  const { width } = useWindowDimensions();

  const positionStyle = width < 470 ? styles.above : styles.right;

  return (
    <View style={positionStyle}>
      <CloseButton
        onPress={onPress}
        bgColor={OwnableTheme.colors.black}
        iconColor={OwnableTheme.colors.white}
        size='medium'
        iconSize={27}
      />
    </View>
  );
});

const styles = StyleSheet.create({
  right: {
    position: 'absolute',
    right: -36,
    top: 0,
  },
  above: {
    position: 'absolute',
    right: 0,
    top: -36,
  },
});
